export default {
  reset({ commit }) {
    commit('reset')
    commit('updateName', '')
    commit('updateText', '')
    commit('updateLoaded', 0)
    commit('updateDescription', '')
  },
  updateLoaded({ commit }, loaded) {
    commit('updateLoaded', loaded)
  },
  updateText({ commit }, loaded) {
    commit('updateText', loaded)
  },
  updateName({ commit }, name) {
    commit('updateName', name)
  },
  updateDescription({ commit }, name) {
    commit('updateDescription', name)
  },
}
